import { BaseEntity } from 'yt-ng-framework';

export class AngazovanjeRoResenje extends BaseEntity {
    constructor() {
        super();
    }
    PodvrstaDokumentaStavkaID: number = null;
    Broj: number = null;
    Datum: Date = null;
    OdDatuma: Date = null;
    OsobaID: number = null;
    TataID: number = null;
    RazlogPrestankaRoID: number = null;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.PodvrstaDokumentaStavkaID=input.PodvrstaDokumentaStavkaID;
        this.Broj=input.Broj;
        this.Datum=input.Datum;
        this.OdDatuma=input.OdDatuma;
        this.OsobaID = input.OsobaID;
        this.TataID=input.TataID;
        this.RazlogPrestankaRoID=input.RazlogPrestankaRoID;
        return this;
    }

    Serialize(input: AngazovanjeRoResenje) {
        return input;
    }
}
